import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BreadcrumbsRoutingModule } from "./breadcrumbs-routing.module";
import { BreadcrumbsComponent } from "./containers/breadcrumbs.component";
import { IconModule } from "../icon/icon.module";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatDividerModule } from "@angular/material/divider";
import { InputWrapperModule } from "../input-wrapper/input-wrapper.module";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { ReactiveFormsModule } from "@angular/forms";
import { BreadcrumbsModalModule } from "./components/breadcrumbs-modal/breadcrumbs-modal.module";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { SharedModule } from "@shared/shared.module";

@NgModule({
	declarations: [BreadcrumbsComponent],
	exports: [BreadcrumbsComponent],
	imports: [
		CommonModule,
		SharedModule,
		BreadcrumbsRoutingModule,
		IconModule,
		MatMenuModule,
		MatDividerModule,
		InputWrapperModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		BreadcrumbsModalModule,
		MatTooltipModule
	]
})
export class BreadcrumbsModule {}
